export var PROSEMIRROR_RENDERED_NORMAL_SEVERITY_THRESHOLD = 2000;
export var PROSEMIRROR_RENDERED_DEGRADED_SEVERITY_THRESHOLD = 3000;
export var DEFAULT_SAMPLING_RATE_VALID_TRANSACTIONS = 100;